import axios from 'axios'
// import Vuetify from 'vuetify'

/**
 * Per accedere globalmente a questo modulo usare rootState, rootGetters negli altri moduli
 *
 * Esempio:
 * getters: {
 *  getRoute(state, getters, rootState) {
 *    return rootState.route;
 *   }
 * }
 */

export default {
	namespaced: true,
	
	state: {
		tipiContrattoDiServizio: [],
		isLoadingTipiContrattoDiServizio: false
	},
	
	getters: {
		tipiContrattoDiServizio(state) {
			return state.tipiContrattoDiServizio;
		},
		isLoadingTipiContrattoDiServizio(state) {
			return state.isLoadingTipiContrattoDiServizio;
		}
	},
	
	mutations: { // è il setter dello store, è sincrona, quindi meglio non usarla per fare chiamate api
		SET_TIPI_CONTRATTO_DI_SERVIZIO (state, tipiContrattoDiServizio) {
			state.tipiContrattoDiServizio = tipiContrattoDiServizio
		},
		SET_IS_LOADING_TIPI_CONTRATTO_DI_SERVIZIO (state, isLoadingTipiContrattoDiServizio) {
			state.isLoadingTipiContrattoDiServizio = isLoadingTipiContrattoDiServizio
		}
	},
	
	actions: { // sono asincrone, posso fare chiamate api e richiamare poi la mutation
		tipiContrattoDiServizio({ commit }) {
			commit('SET_IS_LOADING_TIPI_CONTRATTO_DI_SERVIZIO', true);
			axios.get('/api/tipi-contratto-di-servizio')
				.then(response => {
					commit('SET_TIPI_CONTRATTO_DI_SERVIZIO', response.data);
				})
				.finally(() => {
					commit('SET_IS_LOADING_TIPI_CONTRATTO_DI_SERVIZIO', false);
				})
		}
	}
}